import { Routes } from '@angular/router';
import { ROUTES } from '@shared/constants/routes';
import { PrivateLayout } from 'app/layouts/private-layout/private-layout';
import { dashboardRoutes } from '../../features/private/employer/dashboard/dashboard.routes';


export const employerRoutes: Routes = [
  {
    path: ROUTES.HOME,
    component: PrivateLayout,
    children: [
      {
        path: '',
        loadComponent: () => import('../../features/private/employer/home/home').then((m) => m.Home),
      },
      {
        path: ROUTES.PROFILE,
        loadComponent: () =>
          import('../../features/private/employer/profile/profile').then((m) => m.Profile),
      },
      {
        path: ROUTES.CREATE_OPPORTUNITY,
        loadComponent: () =>
          import('../../features/private/employer/create-opportunity/create-opportunity').then((m) => m.CreateOpportunityEmployer),
      },
      {
        path: ROUTES.DETAIL_OPPORTUNITY,
        loadComponent: () => import('../../features/private/employer/detail-opportunity/detail-opportunity').then((m) => m.DetailOpportunityEmployer),
      },
      {
        path: ROUTES.UPDATE_OPPORTUNITY,
        loadComponent: () =>
          import('../../features/private/employer/update-opportunity/update-opportunity').then((m) => m.UpdateOpportunityEmployer),
      },
      {
        path: ROUTES.YOURS_OPPORTUNITIES,
        loadComponent: () =>
          import('../../features/private/employer/yours-opportunities/yours-opportunities').then((m) => m.YoursOpportunitiesEmployer),
      },
      {
        path: ROUTES.MESSAGES,
        loadComponent: () =>
          import('../../features/chat/chat-layout/chat-layout').then((m) => m.ChatLayoutComponent),
      },
      {
        path: ROUTES.DASHBOARD,
        loadComponent: () =>
          import('../../features/private/employer/dashboard/dashboard').then(
            (m) => m.EmployerDashboardComponent
          ),
        children: dashboardRoutes,
      }
    ],
  },
];
